import { CardSubtitle as t } from "../../Card/Subtitle/CardSubtitle.js";
const o = t;
export {
  o as CollapsibleCardSubtitle
};
